import { RequestDTO } from '@/types/requestDTO';
import { QuickReportingImportRequest, QuickReportingImportResult } from '@/types/reporting/baocaonhanh';
import request from '../base-service';
import { InternalAxiosRequestConfig } from 'axios';
import { reportingView } from '@/types/reporting/ReportingView';
import { EditChiTieuView } from '@/types/performance/edtichitieuviewv2';
import { ApiResponse } from '@/types/base';
import { DataQuickReport, DataReportModel } from '@/types/sdk/model';
import { kpiStatisticsReportPayload, KpiStatisticsReportResult } from '@/types/report';
import { LogFileBaoCaoHistoryView } from '@/types/reporting/LogFileBaoCaoHistoryView';
import { RoleApproveHistoryView } from '@/types/reporting/RoleApproveHistoryView';
import { dashBoardKpiHieuSuat } from '@/types/reporting/dashboardView';
import {
  BaoCaoBackupConfirmRequest,
  // BaoCaoBackupConfirmResult,
  BaoCaoBackupCreateRequest,
  BaoCaoBackupJobProgress,
  BaoCaoBackupListItem,
  BaoCaoBackupPreviewNode,
  BaoCaoBackupPreviewRequest,
  BaoCaoBackupPreviewResult,
} from '@/types/reporting/bao-cao-backup';
// port 9609
// Chạy MS.Reporting local: `npm run local` (CONFIG_NEXT_PUBLIC_REPORTING_API_BASE_URL trong .env.microservices)
const baseUrl = '/v1';
// const kpiStatisticsBaseUrl = 'https://localhost:9609/api/v1/kpistatisticsreport';
const kpiStatisticsBaseUrl = '/v1/kpistatisticsreport';
/** Khoá bước của màn Báo cáo KPIs — BE ghi làm controller log audit (trang Log file → Báo Cáo KPIs), như tenBuoc của bước 1–4. */
const TEN_BUOC_BAO_CAO = 'buoc11';
export const HIEU_SUAT_KPI_CHILDS_REQUEST_KEY = 'hieu-suat-kpi-childs';
/** Tooltip KPI con trên ReportKPIsDetail — tách key để không hủy request dashboard. */
export const HIEU_SUAT_KPI_CHILDS_REPORT_DETAIL_REQUEST_KEY = 'hieu-suat-kpi-childs-report-detail';
export const reportingApi = {
  getTableReporting: (model: RequestDTO) =>
      request.post<reportingView>(`${baseUrl}/reporting/gettablereporting`, model, {
          authorization: true,
      } as InternalAxiosRequestConfig),

  getHieuSuatKPIChilds: (
    model: RequestDTO,
    options?: { abortRequestKey?: string; silentError?: boolean },
  ) =>
    request.post<ApiResponse<dashBoardKpiHieuSuat[]>>(`${baseUrl}/reporting/get-hieu-suat-kpis`, model, {
      authorization: true,
      abortRequestKey: options?.abortRequestKey ?? HIEU_SUAT_KPI_CHILDS_REQUEST_KEY,
      silentError: options?.silentError,
    } as InternalAxiosRequestConfig),

  getHieuSuatKPI: (model: RequestDTO) =>
    request.post<ApiResponse<dashBoardKpiHieuSuat>>(`${baseUrl}/reporting/get-hieu-suat-kpi`, model, {
      authorization: true,
    } as InternalAxiosRequestConfig),

  getBaoCao: (model: RequestDTO) =>
    request.post<ApiResponse<EditChiTieuView>>(`${baseUrl}/reporting/getbaocao`, model, {
      authorization: true,
    } as InternalAxiosRequestConfig),

  getBaoCaoKyNgat: (model: RequestDTO) =>
    request.post<ApiResponse<EditChiTieuView>>(`${baseUrl}/reporting/getbaocaokyngat`, model, {
      authorization: true,
    } as InternalAxiosRequestConfig),

  saveBaoCao: (model: DataReportModel) => {
    const headers: Record<string, string> = {};
    if (model.baoCaoNguon) {
      headers['X-BaoCao-Nguon'] = model.baoCaoNguon;
    }
    const { baoCaoNguon: _nguon, ...body } = model;
    return request.post<boolean>(`${baseUrl}/reporting/savebaocao`, { tenBuoc: TEN_BUOC_BAO_CAO, ...body }, {
      authorization: true,
      headers: Object.keys(headers).length ? headers : undefined,
    } as InternalAxiosRequestConfig);
  },

  xoaBaoCao: (model: RequestDTO) =>
    request.post<boolean>(`${baseUrl}/reporting/xoabaocao`, { tenBuoc: TEN_BUOC_BAO_CAO, ...model }, {
      authorization: true,
    } as InternalAxiosRequestConfig),

  resyncBaoCaoByChiTieu: (model: RequestDTO) =>
    request.post<ApiResponse<boolean>>(`${baseUrl}/reporting/resync-baocao-kpi-choice`, model, {
      authorization: true,
    } as InternalAxiosRequestConfig),

  nhapDanhGia: (model: RequestDTO) =>
    request.post<boolean>(`${baseUrl}/reporting/nhapdanhgia`, { tenBuoc: TEN_BUOC_BAO_CAO, ...model }, {
      authorization: true,
    } as InternalAxiosRequestConfig),

  uploadFile: (model: RequestDTO) =>
    request.post<boolean>(`${baseUrl}/reporting/uploadfile`, { tenBuoc: TEN_BUOC_BAO_CAO, ...model }, {
      authorization: true,
    } as InternalAxiosRequestConfig),

  removeFileBaoCao: (model: RequestDTO) =>
    request.post<boolean>(`${baseUrl}/reporting/removefilebaocao`, { tenBuoc: TEN_BUOC_BAO_CAO, ...model }, {
      authorization: true,
    } as InternalAxiosRequestConfig),

  loghistories: (model: RequestDTO) =>
    request.post<LogFileBaoCaoHistoryView>(`${baseUrl}/reporting/filehistories`, model, {
      authorization: true,
    } as InternalAxiosRequestConfig),

    getTableQuickReporting: (model: RequestDTO) =>
        request.post<reportingView>(`${baseUrl}/reporting/get-table-quick-reporting`, model, {
            authorization: true,
        } as InternalAxiosRequestConfig),

    saveTableQuickReporting: (model: DataQuickReport) =>
        request.post<ApiResponse<any>>(`${baseUrl}/reporting/save-table-quick-reporting`, { tenBuoc: TEN_BUOC_BAO_CAO, ...model }, {
            authorization: true,
        } as InternalAxiosRequestConfig),

    getLockReporting: (model: RequestDTO) =>
        request.post<ApiResponse<any>>(`/v1/config/get-lock-reporting`, model, {
            authorization: true,
        } as InternalAxiosRequestConfig),

    toggleLockReporting: (model: RequestDTO) =>
        request.post<ApiResponse<any>>(`/v1/config/toggle-lock-reporting`, model, {
            authorization: true,
        } as InternalAxiosRequestConfig),

    getUnlockGlobalReporting: (model: RequestDTO) =>
        request.post<ApiResponse<any>>(`/v1/config/get-unlock-global-reporting`, model, {
            authorization: true,
        } as InternalAxiosRequestConfig),

    toggleUnlockGlobalReporting: (model: RequestDTO) =>
        request.post<ApiResponse<any>>(`/v1/config/toggle-unlock-global-reporting`, model, {
            authorization: true,
        } as InternalAxiosRequestConfig),

    downloadQuickReportingTemplate: (model: RequestDTO) =>
        request.post<Blob>(`${baseUrl}/reporting/export-quick-reporting-template`, model, {
            authorization: true,
            responseType: 'blob',
        } as InternalAxiosRequestConfig),
    importQuickReporting: (model: QuickReportingImportRequest) => {
        const formData = new FormData();
        formData.append('PhanHe', model.PhanHe ?? '');
        formData.append('DateChoice', model.DateChoice ?? '');
        formData.append('Frequency', model.Frequency ?? '');
        formData.append('Status', String(model.Status ?? 0));
        formData.append('IDSelected', model.IDSelected ?? '');
        formData.append('File', model.File);
        return request.post<ApiResponse<QuickReportingImportResult>>(
            `${baseUrl}/reporting/import-quick-reporting`,
            formData,
            {
                authorization: true,
                headers: { 'Content-Type': 'multipart/form-data' },
            } as InternalAxiosRequestConfig
        );
    },
  /**
   * Mở modal xét duyệt báo cáo
   * FE chỉ cần gửi trường IDBaoCao trong body (ID của báo cáo).
   * Các thuộc tính khác của RequestDTO có thể bỏ trống/không gửi.
   * @param model Chỉ cần: IDBaoCao (ID của báo cáo)
   */
  openApproveBaoCao: (model: RequestDTO) =>
    request.post<{
      id: string;
      tenkpi: string;
      datechoice: string;
      selectbophan: any;
    }>(`${baseUrl}/reporting/openapprovebaocao`, model, {
      authorization: true,
    } as InternalAxiosRequestConfig),

  /**
   * Lấy lịch sử phê duyệt báo cáo
   * FE chỉ cần gửi trường IDBaoCao và PhanHe trong body (ID của báo cáo và phân hệ).
   * Các thuộc tính khác của RequestDTO có thể bỏ trống/không gửi.
   * @param model Chỉ cần: IDBaoCao (ID của báo cáo) và PhanHe
   */
  approveHistories: (model: RequestDTO) =>
    request.post<RoleApproveHistoryView>(`${baseUrl}/reporting/approvehistories`, model, {
      authorization: true,
    } as InternalAxiosRequestConfig),

  /**
   * Lấy thông tin báo cáo để phê duyệt
   * FE cần gửi các trường: PhanHe, ID (ID chỉ tiêu, tùy chọn), IDNoti (ID notification, tùy chọn), DateChoice (tùy chọn).
   * @param model PhanHe, ID (chỉ tiêu), IDBaoCao (notification), DateChoice
   */
  pheDuyetBaoCao: (model: RequestDTO) =>
    request.post<EditChiTieuView>(`${baseUrl}/reporting/pheduyetbaocao`, model, {
      authorization: true,
    } as InternalAxiosRequestConfig),

  /**
   * Lấy danh sách báo cáo cần phê duyệt để hiển thị modal
   * FE cần gửi các trường: PhanHe, ID (ID approval, tùy chọn), IDNoti (ID notification, tùy chọn).
   * @param model PhanHe, ID (approval), IDBaoCao (notification)
   */
  getModalPheDuyetBaoCao: (model: RequestDTO) =>
    request.post<any[]>(`${baseUrl}/reporting/getmodalpheduyetbaocao`, model, {
      authorization: true,
    } as InternalAxiosRequestConfig),

  approveBaoCao: (model: RequestDTO) =>
    request.post<boolean>(`${baseUrl}/reporting/approvebaocao`, { tenBuoc: TEN_BUOC_BAO_CAO, ...model }, {
      authorization: true,
    } as InternalAxiosRequestConfig),

  approvePheDuyetBaoCao: (model: RequestDTO) =>
    request.post<boolean>(`${baseUrl}/reporting/approvepheduyetbaocao`, { tenBuoc: TEN_BUOC_BAO_CAO, ...model }, {
      authorization: true,
    } as InternalAxiosRequestConfig),

  ///////////////////////////////////////////////////////////////
  //////////////////////  Tong Hop Report //////////////////////

  tongHopReport: (model: kpiStatisticsReportPayload) =>
    request.post<KpiStatisticsReportResult>(`${baseUrl}/tonghop/tonghoptable`, model, {
      authorization: true,
    } as InternalAxiosRequestConfig),

  tongHopExportStart: (model: kpiStatisticsReportPayload) =>
    request.post<{ data: string }>(`${baseUrl}/tonghop/tonghop/export/start`, model, {
      authorization: true,
    } as InternalAxiosRequestConfig),

  tongHopExportProgress: (jobId: string) =>
    request.get<{
      jobId: string;
      processed: number;
      total: number;
      percent: number;
      status: string;
      fileName: string;
      error?: string;
      isReady: boolean;
    }>(`${baseUrl}/tonghop/tonghop/export/progress/${jobId}`, {
      authorization: true,
      silentError: true,
    } as InternalAxiosRequestConfig),

  tongHopExportDownload: (jobId: string) =>
    request.get<Blob>(`${baseUrl}/tonghop/tonghop/export/download/${jobId}`, {
      authorization: true,
      responseType: 'arraybuffer',
      silentError: true,
    } as InternalAxiosRequestConfig),


  //////////////////////  KPI Statistics Report //////////////////////
  kpiStatisticsReport: (model: kpiStatisticsReportPayload) =>
    request.post<KpiStatisticsReportResult>(`${kpiStatisticsBaseUrl}/kpistatisticsreport`, model, {
      authorization: true,
    } as InternalAxiosRequestConfig),

  statisticsReportExportStart: (model: kpiStatisticsReportPayload) =>
    request.post<{ data: string }>(`${kpiStatisticsBaseUrl}/kpistatisticsreport/export/start`, model, {
      authorization: true,
    } as InternalAxiosRequestConfig),

  statisticsReportExportProgress: (id: string) =>
    request.get<{
      jobId: string;
      processed: number;
      total: number;
      percent: number;
      status: string;
      fileName: string;
      error?: string;
      isReady: boolean;
    }>(`${kpiStatisticsBaseUrl}/kpistatisticsreport/export/progress/${id}`, {
      authorization: true,
      silentError: true,
    } as InternalAxiosRequestConfig),

  statisticsReportExportDownload: (id: string) =>
    request.get<Blob>(`${kpiStatisticsBaseUrl}/kpistatisticsreport/export/download/${id}`, {
      authorization: true,
      responseType: 'arraybuffer',
      silentError: true,
    } as InternalAxiosRequestConfig),

  scheduleSyncData: (params?: { syncAllOpenPeriods?: boolean; phanHe?: string; site?: string }) =>
    request.post<ApiResponse<any>>(`${baseUrl}/reporting/schedule-sync-data`, null, {
      authorization: true,
      params: {
        syncAllOpenPeriods: params?.syncAllOpenPeriods ?? false,
        phanHe: params?.phanHe ?? 'bsc',
        ...(params?.site ? { site: params.site } : {}),
      },
    } as InternalAxiosRequestConfig),

};

/** Backup / khôi phục báo cáo KPI — cùng baseUrl MS.Reporting (port 9609). */
const baoCaoBackupBaseUrl = `${baseUrl}/reporting/bao-cao-backup`;
/** Khoá log thao tác backup — trang Log file → Log backup báo cáo (BE ghi theo khoá, như tenBuoc bước 1–4). */
const TEN_BUOC_BACKUP = 'baocaobackup';

export const baoCaoBackupApi = {
  createStart: (model: BaoCaoBackupCreateRequest) =>
    request.post<ApiResponse<string>>(`${baoCaoBackupBaseUrl}/create/start`, { tenBuoc: TEN_BUOC_BACKUP, ...model }, {
      authorization: true,
    } as InternalAxiosRequestConfig),

  list: (params: { year?: number; rootPhuTrachId?: string; phanHe?: string }) =>
    request.get<ApiResponse<BaoCaoBackupListItem[]>>(`${baoCaoBackupBaseUrl}/list`, {
      authorization: true,
      params,
    } as InternalAxiosRequestConfig),

  download: (backupId: string) =>
    request.get<Blob>(`${baoCaoBackupBaseUrl}/${backupId}/download`, {
      authorization: true,
      responseType: 'arraybuffer',
    } as InternalAxiosRequestConfig),

  previewRestore: (model: BaoCaoBackupPreviewRequest) =>
    request.post<ApiResponse<BaoCaoBackupPreviewResult>>(`${baoCaoBackupBaseUrl}/preview-restore`, model, {
      authorization: true,
    } as InternalAxiosRequestConfig),

  previewRestoreSummary: (model: BaoCaoBackupPreviewRequest) =>
    request.post<ApiResponse<BaoCaoBackupPreviewResult>>(`${baoCaoBackupBaseUrl}/preview-restore/summary`, model, {
      authorization: true,
    } as InternalAxiosRequestConfig),

  /** Preview 1 node chạy nền — trả jobId; theo dõi jobProgress rồi lấy kết quả jobResult (node lớn > 1 phút, tránh timeout). */
  previewRestoreNodeStart: (model: BaoCaoBackupPreviewRequest & { phuTrachId: string }) =>
    request.post<ApiResponse<string>>(`${baoCaoBackupBaseUrl}/preview-restore/node/start`, model, {
      authorization: true,
    } as InternalAxiosRequestConfig),

  previewRestoreNode: (model: BaoCaoBackupPreviewRequest & { phuTrachId: string }) =>
    request.post<ApiResponse<BaoCaoBackupPreviewNode>>(`${baoCaoBackupBaseUrl}/preview-restore/node`, model, {
      authorization: true,
    } as InternalAxiosRequestConfig),

  confirmRestoreStart: (model: BaoCaoBackupConfirmRequest) =>
    request.post<ApiResponse<string>>(`${baoCaoBackupBaseUrl}/confirm-restore/start`, { tenBuoc: TEN_BUOC_BACKUP, ...model }, {
      authorization: true,
    } as InternalAxiosRequestConfig),

  jobProgress: (jobId: string) =>
    request.get<ApiResponse<BaoCaoBackupJobProgress>>(`${baoCaoBackupBaseUrl}/job/${jobId}/progress`, {
      authorization: true,
      silentError: true,
    } as InternalAxiosRequestConfig),

  jobResult: <T = unknown>(jobId: string) =>
    request.get<ApiResponse<T>>(`${baoCaoBackupBaseUrl}/job/${jobId}/result`, {
      authorization: true,
      silentError: true,
    } as InternalAxiosRequestConfig),

  delete: (backupId: string) =>
    request.delete<ApiResponse<boolean>>(`${baoCaoBackupBaseUrl}/${backupId}`, {
      authorization: true,
      params: { tenBuoc: TEN_BUOC_BACKUP },
    } as InternalAxiosRequestConfig),
};
